export const blockIconsCommonactionsAccountCircleNew = (
	<span className='material-symbols-outlined'>account_circle</span>
);
